import { createApp } from 'vue'

import SupplierForm from '@/src/javascripts/settings/suppliers/SupplierForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const supplierForm = document.querySelector('#supplier-form')
  if (supplierForm && !supplierForm.__vue_app__) {
    createApp({ components: { SupplierForm, BaseAlert } }).mount(supplierForm)
  }
})
